module.exports = __webpack_public_path__ + "img/2-2.bfe20e43.jpg";